import React, { useEffect, useState } from 'react';
import { defaultPitchBreakdownFilter } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Filters from './Filters';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import Charts from './Charts';

const getDefaultBatterHand = (throwsHand) => (throwsHand === 2 ? 1 : 2);

const BatTracking = () => {
    const { t: translate } = useTranslation();
    const { PlayerID, Throws, IsCatcher } = usePlayerSelector();

    const [filter, setFilter] = useState({
        ...defaultPitchBreakdownFilter,
        batterHand: getDefaultBatterHand(Throws),
    });
    const [levels, setLevels] = useState([]);

    const pitcherId = IsCatcher ? filter.pitcher?.PlayerID : PlayerID;
    const pitcherThrows = IsCatcher ? filter.pitcher?.Throws : Throws;

    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            batterHand: getDefaultBatterHand(pitcherThrows),
        }));
    }, [pitcherId, pitcherThrows]);

    return (
        <div>
            <Header filter={filter} setFilter={setFilter} levels={levels} setLevels={setLevels} />
            {pitcherId ? (
                <>
                    <Filters filter={filter} setFilter={setFilter} />
                    <Charts pitcherId={pitcherId} isLhp={pitcherThrows === 2} filter={filter} levels={levels} />
                </>
            ) : <div className="text-center py-4 px-3 mt-3">{translate('sections.reports.pitcher.use-filters')}</div>}
        </div>
    );
};

export default BatTracking;
